import { render, staticRenderFns } from "./custitle2.vue?vue&type=template&id=24bc4036&scoped=true"
import script from "./custitle2.vue?vue&type=script&lang=js"
export * from "./custitle2.vue?vue&type=script&lang=js"
import style0 from "./custitle2.vue?vue&type=style&index=0&id=24bc4036&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bc4036",
  null
  
)

export default component.exports